export const PRIORITY_FIELD_KEYS = [
  "critical",
  "high",
  "medium",
  "low",
  "info",
];

export const STATUS_FIELD_KEYS = [
  "open",
  "confirmed",
  "acceptRisk",
  "mitigated",
  "falsePositive",
  "suppressed",
  "falsePositive",
];

export const MAPPING_FIELD_FORM_KEYS = {
  summary: "summary",
  description: "description",
  mitigation: "mitigation",
  cwe: "cwe",
  cve: "cve",
  impact: "impact",
  uniqueIdFromTool: "uniqueIdFromTool",
  scanDate: "scanDate",
  foundOnDate: "foundOnDate",
  resolutionDueDate: "resolutionDueDate",
  device: "device",
  componentName: "componentName",
  componentVersion: "componentVersion",
  componentFixVersion: "componentFixVersion",
  url: "url",
  tags: "tags",
  repository: "repository",
  scanType: "scanType",
  category: "category",
  developer: "developer",
  owner: "owner",
  imageName: "imageName",
  imageTag: "imageTag",
  vendor: "vendor",
  host: "host",
  cvssVector: "cvssVector",
  cvssScore: "cvssScore",
  status: "status",
  stepsToReproduce: "stepsToReproduce",
  fileName: "fileName",
  filePath: "filePath",
  ticketId: "ticketId",
  urlEndpoint: "urlEndpoint",
  reopenDate: "reopenDate",
  critical: "critical",
  high: "high",
  medium: "medium",
  low: "low",
  info: "info",
  open: "open",
  confirm: "confirm",
  acceptRisk: "acceptRisk",
  suppressed: "suppressed",
  mitigated: "mitigated",
  falsePositive: "falsePositive",
};

export const JIRA_SECURITY_TOOL_MAPPING_MULTI_SUPPORTED_FIELDS = [
  "summary",
  "description",
  "mitigation",
  "impact",
  "stepsToReproduce",
  "tags",
];

export const TOOL_TYPE_FIELD_OPTIONS = [
  { label: "SCA", value: "SCA" },
  { label: "SAST", value: "SAST" },
  { label: "DAST", value: "DAST" },
  { label: "MAST", value: "MAST" },
  { label: "IAST", value: "IAST" },
  { label: "Bug Bounty", value: "BUG_BOUNTY" },
  { label: "Container Security", value: "CONTAINER_SECURITY" },
  { label: "Infrastructure Tools", value: "INFRASTRUCTURE_TOOLS" },
  { label: "Threat Model", value: "THREAT_MODEL" },
  { label: "CSPM", value: "CSPM" },
  { label: "Pentesting Framework", value: "PENTESTING_FRAMEWORK" },
];
